/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export enum InvoiceSortOption {
    NewestToOldest = 'NewestToOldest',
    OldestToNewest = 'OldestToNewest'
}
